<template>
  <div class="calendar-info-wrapper">
    <!-- 日历信息 -->
    <div class="calendar-info">
      <div class="calendar-date">
        <span class="date-day">{{ currentDate.day }}</span>
        <span class="date-month">{{ currentDate.month }}月</span>
        <span class="calendar-lunar">{{ currentDate.lunar }}</span>
      </div>
      <div class="calendar-weekday">{{ currentDate.weekday }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

// 农历数据
const lunarInfo = [
  0x04bd8, 0x04ae0, 0x0a570, 0x054d5, 0x0d260, 0x0d950, 0x16554, 0x056a0,
  0x09ad0, 0x055d2, 0x04ae0, 0x0a5b6, 0x0a4d0, 0x0d250, 0x1d255, 0x0b540,
  0x0d6a0, 0x0ada2, 0x095b0, 0x14977, 0x04970, 0x0a4b0, 0x0b4b5, 0x06a50,
  0x06d40, 0x1ab54, 0x02b60, 0x09570, 0x052f2, 0x04970, 0x06566, 0x0d4a0,
  0x0ea50, 0x06e95, 0x05ad0, 0x02b60, 0x186e3, 0x092e0, 0x1c8d7, 0x0c950,
  0x0d4a0, 0x1d8a6, 0x0b550, 0x056a0, 0x1a5b4, 0x025d0, 0x092d0, 0x0d2b2,
  0x0a950, 0x0b557, 0x06ca0, 0x0b550, 0x15355, 0x04da0, 0x0a5d0, 0x14573,
  0x052d0, 0x0a9a8, 0x0e950, 0x06aa0, 0x0aea6, 0x0ab50, 0x04b60, 0x0aae4,
  0x0a570, 0x05260, 0x0f263, 0x0d950, 0x05b57, 0x056a0, 0x096d0, 0x04dd5,
  0x04ad0, 0x0a4d0, 0x0d4d4, 0x0d250, 0x0d558, 0x0b540, 0x0b5a0, 0x195a6,
  0x095b0, 0x049b0, 0x0a974, 0x0a4b0, 0x0b27a, 0x06a50, 0x06d40, 0x0af46,
  0x0ab60, 0x09570, 0x04af5, 0x04970, 0x064b0, 0x074a3, 0x0ea50, 0x06b58,
  0x055c0, 0x0ab60, 0x096d5, 0x092e0, 0x0c960, 0x0d954, 0x0d4a0, 0x0da50,
  0x07552, 0x056a0, 0x0abb7, 0x025d0, 0x092d0, 0x0cab5, 0x0a950, 0x0b4a0,
  0x0baa4, 0x0ad50, 0x055d9, 0x04ba0, 0x0a5b0, 0x15176, 0x052b0, 0x0a930,
  0x07954, 0x06aa0, 0x0ad50, 0x05b52, 0x04b60, 0x0a6e6, 0x0a4e0, 0x0d260,
  0x0ea65, 0x0d530, 0x05aa0, 0x076a3, 0x096d0, 0x04bd7, 0x04ad0, 0x0a4d0,
  0x1d0b6, 0x0d250, 0x0d520, 0x0dd45, 0x0b5a0, 0x056d0, 0x055b2, 0x049b0,
  0x0a577, 0x0a4b0, 0x0aa50, 0x1b255, 0x06d20, 0x0ada0,
];

const Gan = ["甲", "乙", "丙", "丁", "戊", "己", "庚", "辛", "壬", "癸"];
const Zhi = [
  "子",
  "丑",
  "寅",
  "卯",
  "辰",
  "巳",
  "午",
  "未",
  "申",
  "酉",
  "戌",
  "亥",
];
const Animals = [
  "鼠",
  "牛",
  "虎",
  "兔",
  "龙",
  "蛇",
  "马",
  "羊",
  "猴",
  "鸡",
  "狗",
  "猪",
];
const lunarMonth = [
  "正",
  "二",
  "三",
  "四",
  "五",
  "六",
  "七",
  "八",
  "九",
  "十",
  "冬",
  "腊",
];
const lunarDay = [
  "初一",
  "初二",
  "初三",
  "初四",
  "初五",
  "初六",
  "初七",
  "初八",
  "初九",
  "初十",
  "十一",
  "十二",
  "十三",
  "十四",
  "十五",
  "十六",
  "十七",
  "十八",
  "十九",
  "二十",
  "廿一",
  "廿二",
  "廿三",
  "廿四",
  "廿五",
  "廿六",
  "廿七",
  "廿八",
  "廿九",
  "三十",
];

// 计算农历
const solarToLunar = (year, month, day) => {
  let i,
    leap = 0,
    temp = 0;

  if (year < 1900 || year > 2100) {
    return null;
  }

  if (year == 1900 && month == 1 && day < 31) {
    return null;
  }

  let offset = Date.UTC(year, month - 1, day) - Date.UTC(1900, 0, 31);
  offset = Math.floor(offset / (24 * 60 * 60 * 1000));

  for (i = 1900; i < 2101 && offset > 0; i++) {
    temp = lYearDays(i);
    offset -= temp;
  }

  if (offset < 0) {
    offset += temp;
    i--;
  }

  const lunarYear = i;
  leap = leapMonth(i);
  let isLeap = false;

  for (i = 1; i < 13 && offset > 0; i++) {
    if (leap > 0 && i == leap + 1 && isLeap == false) {
      --i;
      isLeap = true;
      temp = leapDays(lunarYear);
    } else {
      temp = monthDays(lunarYear, i);
    }

    if (isLeap == true && i == leap + 1) {
      isLeap = false;
    }

    offset -= temp;
  }

  if (offset == 0 && leap > 0 && i == leap + 1) {
    if (isLeap) {
      isLeap = false;
    } else {
      isLeap = true;
      --i;
    }
  }

  if (offset < 0) {
    offset += temp;
    --i;
  }

  const lunarMonthNum = i;
  const lunarDayNum = offset + 1;

  return {
    year: lunarYear,
    month: lunarMonthNum,
    day: lunarDayNum,
    isLeap: isLeap,
    yearGanZhi: cyclical(lunarYear - 1900 + 36),
    zodiac: Animals[(lunarYear - 1900) % 12],
  };
};

const lYearDays = (y) => {
  let i,
    sum = 348;
  for (i = 0x8000; i > 0x8; i >>= 1) {
    sum += lunarInfo[y - 1900] & i ? 1 : 0;
  }
  return sum + leapDays(y);
};

const leapMonth = (y) => {
  return lunarInfo[y - 1900] & 0xf;
};

const leapDays = (y) => {
  if (leapMonth(y)) {
    return lunarInfo[y - 1900] & 0x10000 ? 30 : 29;
  } else {
    return 0;
  }
};

const monthDays = (y, m) => {
  return lunarInfo[y - 1900] & (0x10000 >> m) ? 30 : 29;
};

const cyclical = (num) => {
  return Gan[num % 10] + Zhi[num % 12];
};

// 获取当前日期
const currentDate = computed(() => {
  const now = new Date();
  const weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();

  const lunar = solarToLunar(year, month, day);

  let lunarStr = "";
  if (lunar) {
    const monthStr = lunar.isLeap
      ? "闰" + lunarMonth[lunar.month - 1]
      : lunarMonth[lunar.month - 1];
    lunarStr = monthStr + "月" + lunarDay[lunar.day - 1];
  }

  return {
    day: day,
    month: month,
    weekday: weekdays[now.getDay()],
    lunar: lunarStr,
  };
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.calendar-info-wrapper {
  display: flex;
  align-items: center;
  padding: 8px 16px;
}

/* 日历信息 */
.calendar-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.calendar-date {
  display: flex;
  align-items: baseline;
  gap: 4px;

  .date-day {
    font-size: 24px;
    font-weight: 700;
    color: var(--accent-color);
  }

  .date-month {
    font-size: 12px;
    color: var(--text-secondary);
    transition: color 0.3s ease;
  }
}

.calendar-weekday {
  font-size: 13px;
  color: var(--text-secondary);
  padding-left: 8px;
  border-left: 1px solid var(--border-color);
  transition: color 0.3s ease;
}

@media (max-width: $breakpoint-tablet) {
  .calendar-info-wrapper {
    gap: 12px;
    padding: 6px 12px;
  }

  .calendar-date .date-day {
    font-size: 20px;
  }
}
</style>
